import { checkMatch } from '../general/checkMatch';
import { getCorrelationDelta } from '../general/getCorrelationDelta';
/**
 * Sets proton counts from DEPT90 signals and DEPT135/edited HSQC signals.
 *
 * @param {Values} correlations
 * @param {Array<{ delta: number }>} signals90
 * @param {Array<{ delta: number; sign?: number }>} signals135
 * @param {number} toleranceAtomType
 */
export function setProtonsCount(correlations, signals90, signals135, toleranceAtomType) {
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for (let i = 0; i < correlations.length; i++) {
        const correlation = correlations[i];
        if (correlation.edited.protonsCount) {
            // do not overwrite a manually edited value
            continue;
        }
        const correlationDelta = getCorrelationDelta(correlation);
        const match = [-1, -1];
        for (let k = 0; k < signals90.length; k++) {
            if (
            // signals90[k].sign === 1 &&
            correlationDelta !== undefined &&
                checkMatch(correlationDelta, signals90[k].delta, toleranceAtomType)) {
                match[0] = k;
                break;
            }
        }
        for (let k = 0; k < signals135.length; k++) {
            if (correlationDelta !== undefined &&
                checkMatch(correlationDelta, signals135[k].delta, toleranceAtomType)) {
                match[1] = k;
                break;
            }
        }
        if (match[0] >= 0) {
            // signal match in DEPT90
            // CH
            correlation.protonsCount = [1];
            continue;
        }
        // no signal match in DEPT90
        if (match[1] >= 0) {
            // signal match in DEPT135
            if (signals135[match[1]].sign === 1) {
                // positive signal
                if (signals90.length > 0) {
                    // in case of both DEPT90 and DEPT135 are given
                    // CH3
                    correlation.protonsCount = [3];
                }
                else {
                    // in case of DEPT135 is given only
                    // CH or CH3
                    correlation.protonsCount = [1, 3];
                }
            }
            else {
                // negative signal
                // CH2
                correlation.protonsCount = [2];
            }
        }
        else {
            if (signals135.length > 0) {
                // no signal match in both spectra
                // qC
                correlation.protonsCount = [0];
            }
            else {
                // no information
                correlation.protonsCount = [];
            }
        }
    }
    return correlations;
}
//# sourceMappingURL=data:application/json;base64,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